import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./Blogs.css";

const blogsData = [
  {
    id: 1,
    title: "Purva Patil - Developer",
    author: "Purva Patil",
    role: "Fullstack Developer",
    date: "June 26, 2025",
    category: "Blog",
    comments: 4,
    image: "/Team/purva1.jpeg",
    excerpt: "I work at The  Inovative Solutions  as a Full Stack Developer. Working here has helped me improve my technical knowledge and gain practical experience in modern web development.",
    content: `
      <h2>About My Journey as a Developer</h2>     
      <p>My name is Purva Patil, and I enjoy learning new technologies and building efficient, user-friendly applications.</p>
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at The Inovative Solutions has been a valuable learning experience. I have worked on different web development projects where I improved my frontend development skills, problem-solving abilities, and teamwork. These projects have given me confidence in developing responsive and interactive web applications.</p>
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>HTML</li>
        <li>CSS</li>
        <li>Bootstrap</li>
        <li>javascript</li>
         <li>React.js</li>
      </ul>
      <p>The collaborative environment at Innovative Solutions has allowed me to work with talented colleagues and contribute to meaningful projects that make a real impact.</p>
    `
  },
  {
    id: 2,
    title: "Harshal Deore - Project Manager",
    author: "Harshal Deore",
    role: "Project Manager",
    date: "July 15, 2025",
    category: "Blog",
    comments: 6,
    image: "/Team/harshal1.png",
    excerpt: "From Intern to Project Manager – My Journey at Innovative Solutions. Today, I proudly serve as a Project Manager, where I lead development teams, coordinate project execution, communicate with clients.",
    content: `
      <h2>The World of Frontend</h2>
      <p>My name is Harshal Deore, and I have been a part of Innovative Solutions for over 1.6+ years. What started as an internship has evolved into an incredible professional journey filled with learning, challenges, and achievements.</p>
      
      <h3>My Journey</h3>
      <p>Joining the organization as a React Intern, I focused on mastering frontend development, understanding industry best practices, and building responsive web applications. Through dedication, continuous learning, and hands-on project experience, I was promoted to the role of React Developer, where I worked on multiple client projects using modern web technologies.

Today, I proudly serve as a Project Manager, where I lead development teams, coordinate project execution, communicate with clients, manage timelines, and ensure the successful delivery of software solutions.</p>
      
      <h3>Tools and Technologies</h3>
     <ul>
        <li>React.js & Modern JavaScript (ES6+)</li>
        <li>Node.js & Backend Development</li>
        <li>REST API Design & Integration</li>
        <li>MySQL Database Design & Optimization</li>
        <li>DevOps Practices & CI/CD Pipeline Implementation</li>
        <li>Docker & Containerized Application Deployment</li>
        <li>Git, GitHub & Version Control</li>
        <li>Cloud Deployment & Application Management</li>
        <li>Linux Server Administration & Shell Scripting</li>
        <li>Project Planning & Team Management</li>
        <li>Agile Development & Sprint Planning</li>
        <li>Client Communication & Requirement Gathering</li>
        <li>Technical Documentation & Project Delivery</li>
        <li>Performance Optimization & Application Monitoring</li>
      </ul>
      
    `
  },
  {
    id: 3,
    title: "Shubham Kekane - Software Engineer",
    author: "Shubham Kekane",
    role: "Software Engineer",
    date: "July 20, 2025",
    category: "Blog",
    comments: 1,
    image: "/Team/shubhamsir.jpeg",
    excerpt: "I specialize in MERN stack development, building high-performance web applications, developing hybrid mobile apps (APKs), and engineering secure blockchain solutions.",
    content: `
      <h2>My Growth Journey at Innovative Solutions</h2>
      <p>I have been working as a Software Engineer with Innovative Solutions for the last 3+ years. The best part about working here is the dynamic environment that encourages taking ownership of complex systems, from MERN stack applications to advanced blockchain technologies, and driving professional growth.</p>
      <h3>Professional Development</h3>
      <p>During my tenure at Innovative Solutions, I've had the opportunity to:</p>
      <ul>
        <li>Lead the design and development of scalable web applications using the MERN stack (MongoDB, Express.js, React.js, Node.js)</li>
        <li>Build and deploy high-performance mobile applications and generate production-ready APKs</li>
        <li>Architect and implement secure, decentralized blockchain solutions for modern web ecosystems</li>
        <li>Mentor junior developers, establish robust CI/CD pipelines, and promote clean, maintainable code standards</li>
      </ul>
      <h3>Key Achievements</h3>
      <p>Some of my notable achievements include successfully delivering full-stack MERN projects with 40% faster loading times, launching cross-platform mobile apps for diverse user bases, and integrating tamper-proof blockchain ledger modules for client projects.</p>
      <h3>Future Goals</h3>
      <p>I am eager to continue mastering Web3 and decentralized applications, scaling cloud-native structures, and contributing to Innovative Solutions' success by engineering state-of-the-art web, mobile, and blockchain technologies.</p>
    `
  },
  {
    id: 4,
    title: "Dev Manek - Full Stack Developer",
    author: "Dev Manek",
    role: "Backend Developer",
    date: "August 04, 2025",
    category: "Blog",
    comments: 2,
    image: "/Team/dev.png",
    excerpt: "As a Full Stack Developer Intern at The Innovative Solutions since January 2026, I've gained hands-on experience building scalable web applications using React.js, Node.js, MySQL.",
    content: ` 
      <h2>About My Journey </h2>
      <p>Joining The Innovative Solutions has been one of the most valuable milestones in my professional career. From the beginning, I was trusted with challenging projects that allowed me to strengthen both my frontend and backend development skills. The supportive environment and collaborative culture helped me gain practical industry experience while continuously improving my technical knowledge..</p>
      
      <h3>Technologies I Love</h3>
      <p>I believe that great backend systems should be:</p>
      <ul>
        <li>React.js and modern JavaScript (ES6+)</li>
        <li>REST API development and integration</li>
        <li>MySQL database design and optimization</li>
        <li>Git and GitHub version control</li>
      </ul>
      
      <h3>My Experience at The Innovative Solutions</h3>
      <p>The Innovative Solutions has provided me with valuable industry exposure through real-world software development projects. Working alongside experienced professionals has strengthened my technical expertise and prepared me for a successful career in full-stack development. The internship has been instrumental in improving both my coding skills and professional confidence.</p>
      
      
    `
  },
  {
    id: 5,
    title: "Hindraj Pawar - Backend Developer",
    author: "Hindraj Pawar",
    role: "Backend Developer",
    date: "August 14, 2025",
    category: "Design",
    comments: 5,
    image: "/Team/hindraj.jpeg",
    excerpt: "As a Full Stack Developer Intern at Innovative Solutions, I get the opportunity to learn new technologies, work on real-world projects, and grow as a developer every single day.",
    content: `
      <h2>About My Journey as a Developer</h2>
      <p>My name is Hindraj Pawar, and I work at Innovative Solutions as a Full Stack Developer Intern. My journey in technology started with a curiosity about how applications and websites are built, and over time that curiosity turned into a passion for software development. Every project I work on helps me learn something new and improve my skills.</p>
      <h3>My Design Process</h3>
      <p>My approach to UX design involves:</p>
      <ul>
        <li>Frontend development with modern web technologies</li>
        <li>Backend development and API integration</li>
        <li>Database design and management</li>
        <li>Version control and deployment</li>
      </ul>
      <h3>My Experience at Innovative Solutions</h3>
      <p>Being a part of Innovative Solutions has been an exciting and rewarding experience. As an intern, I have had the chance to work on real projects, collaborate with talented team members, and understand how software products are developed in a professional environment. Each challenge has helped me become more confident as a developer and strengthened my problem-solving abilities.</p>
     
    `
  },
  {
    id: 6,
    title: "Parth Choudhary ",
    author: "Parth Choudhary",
    role: "UI/UX Designer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/parth.jpeg",
    excerpt: "As a UI/UX Design Intern at The Innovative Solutions, I am learning to create intuitive and user-centered designs while working with modern design tools and collaborating with experienced professionals.",
    content: `
      <h2>About my journey as a UI/UX Design Intern</h2>
      <p>My name is Parth Choudhary, and I recently joined "The Innovative Solutions" as a UI/UX Design Intern. Although I have only been with the company for a short time, the experience has been both exciting and educational. It has given me the opportunity to understand professional design workflows and collaborate with a talented team.</p>
      
      <h3>Technologies I Work With</h3>
      <p>My work revolves around:</p>
      <ul>
        <li>Figma for UI design and prototyping</li>
        <li>Wireframing and user flows</li>
        <li>Responsive interface design</li>
        <li>Team collaboration and design reviews</li>
      </ul>
      
      <h3>My Experience at "The Innovative Solutions"</h3>
      <p>During my internship, I have been introduced to the company's design process and have worked on understanding user requirements, wireframing, and interface design. The guidance from my mentors and teammates has helped me improve my design thinking and gain confidence in applying UI/UX principles to real-world projects.</p>
      
    
    `
  },
  {
    id: 7,
    title: "Nishant Ramesh Patil",
    author: "Nishant Ramesh Patil",
    role: "Fullstack Developer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/nishant.jpeg",
    excerpt: "As an aspiring Fullstack Developer, I enjoy building efficient, scalable, and user-friendly web applications using modern technologies.",
    content: `
      <h2>About Me</h2>
      <p>My name is Nishant Ramesh Patil, and I am currently working as an Intern at Innovative Solutions. I have completed 1 month in this role, and I'm excited to learn, grow, and contribute to real-world projects.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>In the past 1 month as an intern, I have gained valuable hands-on experience and exposure to professional development practices. I have been actively involved in learning, exploring new technologies, and supporting the team in various tasks.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>React.js and modern JavaScript frameworks</li>
        <li>Node.js and backend development</li>
        <li>Database design and optimization</li>
        <li>Cloud technologies and deployment</li>
        <li>HTML, CSS, and responsive design</li>
        <li>AI Modules and Integration (e.g., OpenAI API, ML APIs, Prompt Engineering)</li>
      </ul>
      
      <p>I truly appreciate the supportive environment at Innovative Solutions, which encourages learning, collaboration, and personal growth. I look forward to continuing this journey and contributing more effectively in the coming months.</p>
    `
  },
  {
    id: 8,
    title: "Kundan Patil - Developer",
    author: "Kundan Patil",
    role: "Fullstack Developer",
    date: "August 25, 2025",
    category: "Blog",
    comments: 1,
    image: "/Team/kundan.jpeg",
    excerpt: "As a Fullstack Developer at Innovative Solutions, I work with React.js, Node.js, database optimization, and cloud deployment to build scalable solutions.",
    content: `
      <h2>About My Journey as a Developer</h2>
      <p>My name is Kundan Patil, and I work at the Innovative Solutions as a Fullstack Developer. I've been with this organization for almost 1 month now, and I'm glad that I chose this career path.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at Innovative Solutions has been an incredible journey of growth and learning. As a Solution Developer, I've had the opportunity to work on various challenging projects that have enhanced my technical skills and problem-solving abilities.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>React.js and modern JavaScript frameworks</li>
        <li>Node.js and backend development</li>
        <li>Database design and optimization</li>
        <li>Cloud technologies and deployment</li>
      </ul>
      
      <p>The collaborative environment at Innovative Solutions has allowed me to work with talented colleagues and contribute to meaningful projects that make a real impact.</p>
    `
  },
  {
    id: 9,
    title: "Neha Gayakwad - AI/ML Engineer",
    author: "Neha Gayakwad",
    role: "AI/ML Engineer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/neha.png",
    excerpt: "Even within a short period, I have had the opportunity to learn new technologies, understand professional workflows, and work alongside experienced team members.",
    content: `
      <h2>About My Journey at The Innovative Solutions</h2>
      <p>My name is Neha Gayakawad, and I joined The Innovative Solutions one month ago. Even within this short period, I have had the opportunity to learn new technologies, understand professional workflows, and work alongside experienced team members. I am grateful to be a part of this organization and look forward to growing my skills.</p>
      
      <h3>My Experience at The Innovative Solutions</h3>
      <p>During my first month, I have been introduced to practical development concepts and real-world projects. The guidance and support provided by my mentors and colleagues have helped me improve my technical knowledge and gain confidence in my work. Every day has been a valuable learning experience.</p>
      
      <h3>Key Learnings</h3>
      <ul>
        <li>Gained exposure to real-time software development practices.</li>
        <li>Learned to work with modern development tools and technologies.</li>
        <li>Improved my problem-solving and debugging skills.</li>
        <li>Understood the importance of teamwork and effective communication.</li>
        <li>Developed confidence by working on practical tasks and projects.</li>
      </ul>
      
      <p>Although I have been with The Innovative Solutions for only one month, my experience has been positive and motivating. The friendly work culture, supportive mentors, and continuous learning opportunities have made this an excellent place to begin my professional career. I look forward to learning more, taking on new challenges, and contributing to the organization's success.</p>
    `
  },
  {
    id: 10,
    title: "Tanmay Tambe - Developer",
    author: "Tanmay Tambe",
    role: "Fullstack Developer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/tanyaa.png",
    excerpt: "As a Fullstack Developer at The Innovative Solutions, I work with React.js, Node.js, database optimization, and cloud deployment to build scalable solutions.",
    content: `
      <h2>About My Journey as a Developer</h2>
      <p>My name is Tanmay Tambe, and I work at The Innovative Solutions as a Fullstack Developer. I've been with this organization for almost 3 months now, and I'm glad that I chose this career path.</p>
      
      <h3>My Experience at The Innovative Solutions</h3>
      <p>Working at The Innovative Solutions has been an incredible journey of growth and learning. As a Fullstack Developer, I've had the opportunity to work on various challenging projects that have enhanced my technical skills and problem-solving abilities.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>React.js and modern JavaScript frameworks</li>
        <li>Node.js and backend development</li>
        <li>Database design and optimization</li>
        <li>Cloud technologies and deployment</li>
      </ul>
      
      <p>The collaborative environment at The Innovative Solutions has allowed me to work with talented colleagues and contribute to meaningful projects that make a real impact.</p>
    `
  },
  {
    id: 11,
    title: "Rutuja Kapse - Developer",
    author: "Rutuja Kapse",
    role: "Fullstack Developer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/rutuja.jpeg",
    excerpt: "My name is Rutuja Kapse, and I am an aspiring Fullstack Developer passionate about building responsive and user-friendly web applications.",
    content: `
      <h2>About Me</h2>
      <p>My name is Rutuja Kapse, and I am an aspiring Fullstack Developer. I am passionate about building responsive and user-friendly web applications. I enjoy learning new technologies and continuously improving my technical and problem-solving skills. My goal is to build innovative software solutions and grow as a professional in the IT industry.</p>
      
      <h3>My Experience as a Developer</h3>
      <p>I have worked on academic and personal projects that have strengthened my programming knowledge and practical development skills. Through these projects, I have improved my problem-solving abilities, teamwork, and communication skills while gaining hands-on experience in web development.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>HTML</li>
        <li>CSS</li>
        <li>Bootstrap</li>
        <li>JavaScript</li>
        <li>React.js</li>
        <li>Java</li>
        <li>MySQL</li>
      </ul>
    `
  },
  {
    id: 12,
    title: "Mrug Rajguru - Human Resource",
    author: "Mrug Rajguru",
    role: "Human Resource",
    date: "August 25, 2025",
    category: "Business",
    comments: 1,
    image: "/Team/mrug.jpeg",
    excerpt: "As a Human Resource at Innovative Solutions, I work with Employee satisfaction, Employee growth, work culture, Ethics, Recruitment, and Unbiased professionalism.",
    content: `
      <h2>About My Journey in Human Resources</h2>
      <p>My name is Mrug Rajguru and I work at the Innovative Solutions as a Human Resources. I've been with this organisation for almost 3 months now, and I'm glad that I chose this career path.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at Innovative Solutions has been an incredible journey of growth and learning. As a Solution HR, I've had the opportunity to work on various challenging projects that have enhanced my technical skills and problem-solving abilities.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Talent Acquisition and Recruitment</li>
        <li>Employee Relations and Conflict Resolution</li>
        <li>Performance Management and Employee Engagement</li>
        <li>HR Policies, Compliance, and Labor Laws</li>
        <li>Payroll and Attendance Management</li>
        <li>Training and Development Coordination</li>
        <li>Onboarding and Offboarding Processes</li>
        <li>HR Analytics and Reporting</li>
        <li>Applicant Tracking Systems (ATS)</li>
        <li>HRIS (Human Resource Information Systems)</li>
        <li>Microsoft Excel, Word, and PowerPoint</li>
        <li>Google Workspace (Docs, Sheets, Forms)</li>
        <li>LinkedIn Recruiter and Job Portals (Naukri, Indeed, etc.)</li>
        <li>Communication, Negotiation, and Interpersonal Skills</li>
        <li>Organizational and Time Management Skills</li>
      </ul>
      
      <p>The collaborative environment at Innovative Solutions has allowed me to work with talented colleagues and contribute to meaningful projects that make a real impact.</p>
    `
  },
  {
    id: 13,
    title: "Shruti Ganore - Business Analyst",
    author: "Shruti Ganore",
    role: "Business Analyst",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/shruti.jpg",
    excerpt: "I work at The Innovative Solutions Nashik as a Business Analyst Intern. I'm glad that I chose this career path to bridge the gap between complex business challenges and technical solutions.",
    content: `
      <h2>About My Journey as a Business Analyst</h2>
      <p>My name is Shruti Balkrishna Ganore, and I work at The Innovative Solutions Nashik as a Business Analyst Intern. I'm glad that I chose this career path to bridge the gap between complex business challenges and technical solutions.</p>
      
      <h3>My Experience at The Innovative Solutions</h3>
      <p>Working at The Innovative Solutions has been an incredible journey of growth and learning. As a Business Analyst Intern, I've had the opportunity to work on various challenging projects that have significantly enhanced my data interpretation, problem-solving, and strategic thinking abilities. I get to dive into everyday business challenges, collaborate with different teams, and suggest practical ways to improve how we get things done.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li><strong>Excel & Data Charts:</strong> Using tools like Excel to turn raw numbers into clear, easy-to-understand charts and dashboards.</li>
        <li><strong>Improving Workflows:</strong> Looking at how a process is done right now, finding the bottlenecks, and designing a better way to do it.</li>
        <li><strong>Connecting Teams:</strong> Acting as a bridge between the business side and the technical side so everyone is on the same page.</li>
        <li><strong>Gathering Requirements:</strong> Talking to people to find out what they need and writing it down clearly so the team can build it.</li>
      </ul>
      
      <p>Working here has made me really enjoy solving problems and planning out smart business steps. It is great to see the work I do actually help the team succeed.</p>
    `
  },
  {
    id: 14,
    title: "Dhrumin Bhavsar - AI Engineer",
    author: "Dhrumin Bhavsar",
    role: "AI Engineer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/dhrumin.jpeg",
    excerpt: "As an AI Engineer Intern at Innovative Solutions, I am working with machine learning, computer vision, and data analytics to build intelligent systems that solve real-world problems.",
    content: `
      <h2>About My Journey as a Developer</h2>
      <p>My name is Dhrumin Kumar Bhavsar, and I am currently interning at Innovative Solutions as an AI Engineer. I've been with the organization for about a month now, and I'm already glad that I chose this path. Getting hands-on exposure to real AI projects so early in my career has been both exciting and deeply rewarding.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Even in just one month at Innovative Solutions, it has been an incredible start to my professional journey. As an AI Engineering intern, I've been diving into machine learning workflows, exploring computer vision tasks, and working with data to extract meaningful insights. The team here has been incredibly supportive, and every day brings a new learning opportunity that is shaping me into a stronger AI practitioner.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Machine learning and predictive modeling (scikit-learn, TensorFlow, PyTorch)</li>
        <li>Computer vision — image classification, object detection, and segmentation</li>
        <li>Data science and analytics — EDA, feature engineering, and statistical modeling</li>
        <li>Python and end-to-end ML pipeline development</li>
      </ul>
      
      <p>The collaborative and growth-focused environment at Innovative Solutions has given me the opportunity to work alongside talented professionals and contribute to meaningful AI projects right from the start of my career.</p>
    `
  },
  {
    id: 15,
    title: "Vinayak Patil - AI Engineer",
    author: "Vinayak Patil",
    role: "AI Engineer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/vina.jpeg",
    excerpt: "As an AI Engineer at Innovative Solutions, I work on Artificial Intelligence, Computer Vision, Python, and AI-powered automation to build intelligent and scalable solutions.",
    content: `
      <h2>About My Journey as an AI Engineer</h2>
      <p>My name is Vinayak Patil, and I work at Innovative Solutions as an AI Engineer. During my time with the organization, I have been involved in developing AI-based applications and intelligent automation solutions. Working on real-world projects has strengthened my technical knowledge and helped me grow as an AI professional.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at Innovative Solutions has been an incredible learning experience. As an AI Engineer, I have had the opportunity to work on innovative projects involving Artificial Intelligence, Computer Vision, Machine Learning, and backend development. These projects have enhanced my technical skills, problem-solving abilities, and experience in building real-world AI solutions.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Python and AI Development</li>
        <li>Computer Vision using YOLO and OpenCV</li>
        <li>Machine Learning and Deep Learning</li>
        <li>FastAPI and Backend Development</li>
        <li>React.js and Node.js</li>
        <li>MySQL and Database Management</li>
        <li>WhatsApp Cloud API Integration</li>
        <li>Git and GitHub</li>
      </ul>
    `
  },
  {
    id: 16,
    title: "Kunal Desale - Graphic Designer",
    author: "Kunal Desale",
    role: "Graphic Designer",
    date: "August 25, 2025",
    category: "Design",
    comments: 1,
    image: "/Team/kunal.png",
    excerpt: "I work at Innovative Solutions as a Graphic Designer. Over the year, I have developed a passion for creating designs that effectively communicate ideas and leave a lasting impression.",
    content: `
      <h2>About My Journey as a Graphic Designer</h2>
      <p>My name is Kunal Desale, and I work at Innovative Solutions as a Graphic Designer. Over the year, I have developed a passion for creating designs that effectively communicate ideas and leave a lasting impression. Every project has helped me grow creatively while improving my technical and problem-solving skills.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at Innovative Solutions has been an inspiring journey filled with creativity and continuous learning. I've had the opportunity to design branding materials, social media creatives, marketing campaigns, and digital assets that contribute to the company's success. The supportive environment has encouraged me to explore new design trends and deliver high-quality visual solutions.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Adobe Photoshop</li>
        <li>Adobe Illustrator</li>
        <li>Social Media & Marketing Creative Design</li>
        <li>Brand Identity and Logo Design</li>
        <li>Print Design and Digital Media</li>
        <li>UI/UX Design Principles</li>
        <li>Typography, Color Theory, and Layout Design</li>
      </ul>
      
      <p>The collaborative culture at Innovative Solutions has allowed me to work with talented professionals, enhance my creativity, and contribute to meaningful projects that create a positive impact. I'm grateful to be part of a team that values innovation, creativity, and continuous growth.</p>
    `
  },
  {
    id: 17,
    title: "Sneha Tambe - Data Analyst",
    author: "Sneha Tambe",
    role: "Data Analyst",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/sneha1.jpeg",
    excerpt: "As a Data Analyst at Innovative Solutions, I work with Excel, SQL, Power BI, Python, and data visualization tools to transform raw data into meaningful insights that support better business decisions.",
    content: `
      <h2>About My Journey as a Data Analyst</h2>
      <p>My name is Sneha Kailas Tambe, and I work at Innovative Solutions as a Data Analyst. Working with this organization has been an enriching experience where I have developed strong analytical thinking, business understanding, and technical skills. The opportunity to work with real-world datasets has helped me grow professionally and build confidence in solving business problems through data.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at Innovative Solutions has been an excellent learning journey. As a Data Analyst, I have analyzed business data, created interactive dashboards, generated performance reports, and identified trends that support strategic decision-making. The projects and collaborative work environment have strengthened my problem-solving abilities and enhanced my understanding of business analytics.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Microsoft Excel (Advanced Functions, Pivot Tables, Power Query)</li>
        <li>SQL for data extraction and analysis</li>
        <li>Power BI for dashboard creation and visualization</li>
        <li>Python for data analysis and automation</li>
        <li>Data Cleaning, Data Transformation, and Reporting</li>
        <li>Business Analytics and KPI Tracking</li>
      </ul>
      
      <p>The supportive and collaborative environment at Innovative Solutions has enabled me to continuously improve my analytical skills, work on impactful business projects, and contribute to data-driven decision-making. This experience has played a significant role in shaping my career as a Data Analyst and preparing me for future opportunities in the analytics domain.</p>
    `
  },
  {
    id: 18,
    title: "Dnyaneshwar Pawar - Graphic Designer",
    author: "Dnyaneshwar Pawar",
    role: "Graphic Designer",
    date: "August 25, 2025",
    category: "Design",
    comments: 1,
    image: "/Team/darshan.png",
    excerpt: "I'm Dnyaneshwar Pawar, a passionate Graphic Designer at Innovative Solutions. Over the past 4 months, I've been transforming ideas into compelling visual experiences.",
    content: `
      <h2>Creative Journey</h2>
      <p>Hello! I'm Dnyaneshwar Pawar, a passionate Graphic Designer at Innovative Solutions. Over the past 4 months, I've been transforming ideas into compelling visual experiences that connect brands with their audience. Design, for me, is more than aesthetics—it's about creating meaningful communication through creativity.</p>
      
      <h3>What I Do</h3>
      <p>At Innovative Solutions, I contribute to a variety of creative projects, including branding, social media campaigns, digital advertisements, and promotional designs. Every assignment presents a new opportunity to solve visual challenges and craft designs that are both engaging and effective.</p>
      <p>Working with diverse clients and teams has helped me strengthen my creative thinking while maintaining a strong focus on quality and attention to detail.</p>
      
      <h3>My Design Expertise</h3>
      <ul>
        <li>Brand Identity Design</li>
        <li>Social Media Creatives</li>
        <li>Poster & Banner Design</li>
        <li>Marketing & Advertising Materials</li>
        <li>Photo Editing & Manipulation</li>
        <li>UI Design Fundamentals</li>
        <li>Print & Digital Media</li>
        <li>Typography & Layout Design</li>
      </ul>
      
      <h3>Tools I Work With</h3>
      <ul>
        <li>Adobe Photoshop</li>
        <li>Adobe Illustrator</li>
        <li>Canva</li>
        <li>Adobe Premiere Pro (Basic)</li>
      </ul>
      
      <h3>Design Philosophy</h3>
      <p>I believe every design should have a purpose. Whether it's building a brand identity or creating a social media campaign, my goal is to combine creativity with strategy to produce visuals that leave a lasting impression. I enjoy learning new trends, experimenting with fresh ideas, and continuously improving my skills to deliver impactful designs.</p>
    `
  },
  // { 
  //   id: 19,
  //   title: "Dev Manek - Full Stack Developer",
  //   author: "Dev Manek",
  //   role: "Full Stack Developer",
  //   date: "August 25, 2025",
  //   category: "Technology",
  //   comments: 1,
  //   image: "/Team/dev.jpeg",
  //   excerpt: "As a Full Stack Developer Intern at The Innovative Solutions since January 2026, I've gained hands-on experience building scalable web applications using React.js, Node.js, MySQL, and modern development tools while working on real-world projects.",
  //   content: `
  //     <h2>About My Journey at The Innovative Solutions</h2>
  //     <p>Joining The Innovative Solutions has been one of the most valuable milestones in my professional career. From the beginning, I was trusted with challenging projects that allowed me to strengthen both my frontend and backend development skills. The supportive environment and collaborative culture helped me gain practical industry experience while continuously improving my technical knowledge.</p>

  //     <h3>My Experience at The Innovative Solutions</h3>
  //     <p>Working at The Innovative Solutions has been an enriching learning experience. As a Full Stack Developer Intern, I have worked on frontend and backend development, REST API integration, database management, bug fixing, and deployment tasks. The company provides a collaborative work environment where interns are encouraged to take ownership of projects, learn new technologies, and deliver high-quality software solutions.</p>

  //     <h3>Key Skills and Technologies</h3>
  //     <ul>
  //       <li>React.js and modern JavaScript (ES6+)</li>
  //       <li>Node.js and Express.js backend development</li>
  //       <li>REST API development and integration</li>
  //       <li>MySQL database design and optimization</li>
  //       <li>Git and GitHub version control</li>
  //       <li>HTML5, CSS3, and responsive web design</li>
  //       <li>Debugging, testing, and performance optimization</li>
  //       <li>Team collaboration and Agile development</li>
  //     </ul>

  //     <p>The Innovative Solutions has provided me with valuable industry exposure through real-world software development projects. Working alongside experienced professionals has strengthened my technical expertise and prepared me for a successful career in full-stack development. The internship has been instrumental in improving both my coding skills and professional confidence.</p>
  //   `
  // },
  {
    id: 20,
    title: "Khushal Lohar - AI/ML Engineer",
    author: "Khushal Lohar",
    role: "AI/ML Engineer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/kushal.jpeg",
    excerpt: "As an AI/ML Engineer at Innovative Solutions, I develop intelligent applications using Machine Learning, Deep Learning, and Computer Vision.",
    content: `
      <h2>About My Journey as an AI/ML Engineer</h2>
      <p>My name is Khushal Lohar, and I work at Innovative Solutions as an AI/ML Engineer. This role has given me the opportunity to strengthen my expertise in Artificial Intelligence, Machine Learning, and software development while working on challenging real-world projects.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at Innovative Solutions has been a valuable learning experience. I have contributed to AI-driven projects involving data analysis, model training, computer vision, and intelligent automation. Collaborating with experienced professionals has helped me improve my technical, analytical, and problem-solving skills.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Python</li>
        <li>Machine Learning & Deep Learning</li>
        <li>Computer Vision (YOLO, OpenCV)</li>
        <li>TensorFlow & PyTorch</li>
        <li>Data Preprocessing and Model Training</li>
        <li>REST APIs and AI Integration</li>
        <li>Git & GitHub</li>
        <li>Cloud Deployment and Model Deployment</li>
      </ul>
      
      <p>I enjoy building practical AI solutions that improve efficiency and solve real-world challenges while continuously learning and exploring emerging technologies in the field of Artificial Intelligence.</p>
    `
  },
  {
    id: 21,
    title: "Chaitanya Sonaje - Full Stack Developer",
    author: "Chaitanya Sonaje",
    role: "Full Stack Developer",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/chaita.png",
    excerpt: "As a Full Stack Developer, I specialize in React.js, Node.js, database optimization, and cloud deployment to build scalable and efficient solutions.",
    content: `
      <h2>Feedback as a Full Stack Developer</h2>
      <p>Working as a Full Stack Developer has been an incredible journey of learning and professional growth. Throughout my experience, I have had the opportunity to work on diverse projects that strengthened my technical expertise and problem-solving skills.</p>
      
      <h3>My Experience as a Full Stack Developer</h3>
      <p>I have contributed to the development of modern web applications by working across both frontend and backend technologies. Building scalable architectures, optimizing application performance, and delivering user-focused solutions have been key aspects of my role.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>React.js and modern JavaScript frameworks</li>
        <li>Node.js and backend development</li>
        <li>Database design and optimization</li>
        <li>REST APIs and system integration</li>
        <li>Cloud technologies and deployment</li>
        <li>Version control and collaborative development</li>
      </ul>
      
      <p>The experience of working on challenging projects and collaborating with talented teams has helped me grow as a developer and continuously improve my skills. I look forward to creating more innovative and impactful solutions in the future.</p>
    `
  },
  {
    id: 22,
    title: "Rahul Wagh - Data Analyst",
    author: "Rahul Wagh",
    role: "Data Analyst",
    date: "June 26, 2026",
    category: "Technology",
    comments: 1,
    image: "/Team/rahul.PNG",
    excerpt: "As a Data Analyst Intern at The Innovative Solutions, Nashik, I work with Advanced Excel, Power BI, SQL, and data visualization techniques to transform raw data into meaningful insights and support data-driven business decisions.",
    content: `
      <h2>About My Journey as a Data Analyst</h2>
      <p>My name is Rahul Wagh, and I am currently working as a Data Analyst Intern at The Innovative Solutions, Nashik. I joined the organization in June 2026, where I have been gaining hands-on experience in data analysis and business intelligence. This internship has provided me with an excellent opportunity to apply analytical concepts in a professional environment while continuously expanding my technical skills.</p>
      <p>I am passionate about working with data and enjoy transforming complex datasets into meaningful insights that help businesses make informed decisions. Every project allows me to strengthen my problem-solving abilities and deepen my understanding of modern data analytics tools and techniques.</p>
      
      <h3>My Experience at The Innovative Solutions</h3>
      <p>At The Innovative Solutions, I work on a variety of data-related tasks that contribute to efficient business reporting and decision-making. My responsibilities include data cleaning in Microsoft Excel, creating interactive dashboards, preparing reports, writing SQL queries, developing Power BI reports, and designing data visualizations. I also work extensively with Pivot Tables and Charts to analyze and present business data effectively.</p>
      <p>This experience has enhanced my analytical thinking, attention to detail, and ability to convert raw data into actionable business insights while collaborating in a professional work environment.</p>
      
      <h3>Key Skills & Technologies</h3>
      <ul>
        <li>Advanced Excel</li>
        <li>Power BI</li>
        <li>SQL</li>
        <li>Data Analysis</li>
        <li>Dashboard Design</li>
        <li>Data Cleaning</li>
        <li>Data Visualization</li>
        <li>Pivot Tables & Charts</li>
        <li>Business Analytics</li>
        <li>Report Preparation</li>
      </ul>
    `
  },
  { 
    id: 23,
    title: "Vaibhav Gaikar - Data Analyst",
    author: "Vaibhav Gaikar",
    role: "Data Analyst",
    date: "August 25, 2025",
    category: "Technology",
    comments: 1,
    image: "/Team/vaibhav.png",
    excerpt: "My name is Vaibhav Gaikar, and I work at The Innovative Solutions as a Data Analyst. Working with this organization has been an enriching experience.",
    content: `
      <h2>About My Journey as a Data Analyst</h2>
      <p>My name is Vaibhav Gaikar, and I work at The Innovative Solutions as a Data Analyst. I've been with this organisation for the last few months, and I am pleased that I chose my career here.</p>
      
      <h3>My Experience at Innovative Solutions</h3>
      <p>Working at The Innovative Solutions as a Data Analyst has been fantastic. During my time here, I have learned various concepts and skills that are helping me grow professionally in this domain.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Business analysis and requirements gathering</li>
        <li>SQL for Data analysis</li>
        <li>Data cleaning and data transformation</li>
      </ul>
    `
  },
  {
    id: 24,
    title: "Dhanashree Kangane - Business Analyst",
    author: "Dhanashree Kangane",
    role: "Business Analyst",
    date: "August 25, 2025",
    category: "Business",
    comments: 1,
    image: "/Team/dhanashree.jpeg",
    excerpt: "As an aspiring Business Analyst, I transform data into meaningful insights, bridge the gap between business and technology, and support data-driven decision-making to improve organizational performance.",
    content: `
      <h2>About My Journey as a Business Analyst</h2>
      <p>My name is Dhanashree Kangane, and I am an MBA student specializing in Business Analytics with a strong passion for solving business problems through data. My journey into business analytics began with an interest in understanding how organizations make strategic decisions using data. Through academic projects, internships, and hands-on experience with analytical tools, I have developed a strong foundation in data analysis, visualization, and business intelligence. Every project has strengthened my analytical thinking, communication, and problem-solving skills, motivating me to build a successful career as a Business Analyst.</p>
      
      <h3>My Experience</h3>
      <p>Throughout my academic journey and internship, I have worked on several real-world business analytics projects involving market research, customer behavior analysis, brand loyalty, social media impact on purchasing behavior, and dashboard creation. During my internship at Innovative Solutions, I gained practical exposure to live projects, data analysis, report preparation, and business problem-solving. These experiences have enhanced my ability to gather requirements, analyze data, generate actionable insights, and present findings effectively to support informed business decisions.</p>
      
      <h3>Key Skills and Technologies</h3>
      <ul>
        <li>Business Analysis and Requirements Gathering</li>
        <li>Microsoft Excel (Advanced Functions, Pivot Tables, Dashboards)</li>
        <li>Power BI and Data Visualization</li>
        <li>SQL for Data Analysis</li>
        <li>Python (Basics for Data Analytics)</li>
        <li>Data Cleaning and Data Transformation</li>
        <li>Market Research and Business Intelligence</li>
        <li>Statistical Analysis and Reporting</li>
        <li>Problem Solving and Critical Thinking</li>
        <li>Communication, Presentation, and Stakeholder Management</li>
      </ul>
      
      <h3>What I Value</h3>
      <p>I believe that every business decision should be supported by accurate data and meaningful insights. I value continuous learning, integrity, collaboration, and innovation. I enjoy working with teams, understanding business challenges, and finding practical, data-driven solutions that create value for organizations. My goal is to contribute as a Business Analyst by helping businesses make smarter decisions, improve operational efficiency, and achieve sustainable growth.</p>
    `
  },

];

export default function Blogs() {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;

  // Pagination Logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogsData.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogsData.length / blogsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15
      }
    },
    exit: {
      opacity: 0,
      scale: 0.95,
      y: 10,
      transition: { duration: 0.2 }
    }
  };

  const getWatermarkText = (role) => {
    const r = role.toLowerCase();
    if (r.includes("manager")) return "Manager";
    if (r.includes("analyst")) return "Analyst";
    if (r.includes("ui/ux")) return "UI/UX";
    if (r.includes("hr") || r.includes("human resource")) return "HR";
    if (r.includes("fullstack") || r.includes("full stack")) return "Developer";
    if (r.includes("ai/ml") || r.includes("ai engineer")) return "AI/ML";
    if (r.includes("designer")) return "UI/UX";
    if (r.includes("frontend")) return "Frontend";
    if (r.includes("backend")) return "Backend";
    return "Developer";
  };

  return (
    <div className="blogs-page-wrapper">
      {/* Background blobs */}
      <div className="blogs-bg-decorations">
        <div className="blogs-decor-blob blogs-decor-blob-1"></div>
        <div className="blogs-decor-blob blogs-decor-blob-2"></div>
      </div>

      <div className="container py-5 mt-5 position-relative" style={{ zIndex: 2 }}>
        {/* Header section */}
        <div className="text-center mb-5 mt-4">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="blogs-title"
          >
            Our Blog
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="blogs-subtitle"
          >
            Insights, experiences, and stories from our talented team at The Innovative Solutions.
          </motion.p>
        </div>

        {/* Blog Cards list */}
        <motion.div
          layout
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="row g-4 mb-4"
        >
          <AnimatePresence mode="popLayout">
            {currentBlogs.map((blog) => (
              <motion.div
                layout
                key={blog.id}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                className="col-lg-4 col-md-6"
              >
                <Link to={`/blog/${blog.id}`} className="glass-quote-card">
                  {/* Decorative Quotation Mark */}
                  <div className="quote-icon-decor">“</div>

                  {/* Watermark Background Text */}
                  <div className="quote-watermark-text">
                    {getWatermarkText(blog.role)}
                  </div>

                  {/* Excerpt Block */}
                  <p className="quote-excerpt-text">"{blog.excerpt}"</p>

                  {/* Divider line */}
                  <hr className="quote-card-divider" />

                  {/* Author Details & Read More Row */}
                  <div className="quote-author-row-layout">
                    <div className="quote-author-section">
                      <img
                        src={blog.image}
                        alt={blog.author}
                        className="quote-author-avatar"
                        onError={(e) => {
                          e.target.src = "https://via.placeholder.com/150/0d6efd/ffffff?text=User";
                        }}
                      />
                      <div className="quote-author-info">
                        <h5 className="quote-author-name">{blog.author}</h5>
                        <span className="quote-author-role">{blog.role}</span>
                      </div>
                    </div>

                    {/* Animated Read More Action */}
                    <div className="quote-read-more-btn">
                      <span>Read More</span>
                      <svg className="read-more-arrow" viewBox="0 0 24 24">
                        <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="blogs-pagination-container">
            <button
              className="glass-page-btn glass-page-nav-btn"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                className={`glass-page-btn ${currentPage === index + 1 ? "active" : ""}`}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            ))}

            <button
              className="glass-page-btn glass-page-nav-btn"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export { blogsData };
